import React from "react";
import { BrowserRouter } from "react-router-dom";

import Routes from "./Routes";
import "./App.css";

import { AccountContext } from "services/account";
import { updateToken } from "services/api";
import { Navigator } from "components/Navigator";

function App() {
	const account = React.useContext(AccountContext);
	React.useEffect(() => {
		// Return if No Auth
		if (!account.value || account.getRole() === "organizationUser") return;

		const now = Date.now();
		const threeDayBefore = 3 * 24 * 60 * 60 * 1000;

		const diffInMs = Math.abs(now - account.value?.tokenUpdateTime);
		// Convert milliseconds to seconds, minutes, hours, and days
		const seconds = Math.floor(diffInMs / 1000);
		const minutes = Math.floor(seconds / 60);
		const hours = Math.floor(minutes / 60);
		const days = Math.floor(hours / 24);

		// Create a readable output
		console.log(`${days} days, ${hours % 24} hours, ${minutes % 60} minutes, ${seconds % 60} seconds`);

		if (!account.value?.tokenUpdateTime || now - threeDayBefore > account.value?.tokenUpdateTime) {
			updateToken().then((resp) => {
				if (!resp || resp?.error) return;
				console.log("Old: " + account.getToken() + "\nNew: " + resp.secretKey);
				account.setAccount({ secretKey: resp.secretKey, tokenUpdateTime: now });
			});
		}
	}, []);

	return (
		<>
			<BrowserRouter>
				<Navigator />
				<Routes />
			</BrowserRouter>
		</>
	);
}

export default App;
